import React from 'react';
import { cx } from '../../utils/cx.js';

// Shared form-control look (inputs, textareas, selects).
export const INPUT_CLASS = cx(
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm outline-none transition-shadow',
  'placeholder:text-gray-400 focus:border-brand-400 focus:ring-4 focus:ring-brand-500/15',
  'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500',
  'dark:border-gray-800 dark:bg-night-850 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-brand-500',
  'dark:disabled:bg-night-900 dark:disabled:text-gray-500',
);

/** Label + control + hint/error, stacked. Pass the control as children with a matching id. */
const Field = ({ label, htmlFor, hint = null, error = null, required = false, className = '', children }) => (
  <div className={cx('text-left', className)}>
    {label && (
      <label htmlFor={htmlFor} className="mb-1.5 block text-xs font-semibold text-gray-700 dark:text-gray-300">
        {label}
        {required && <span className="ml-0.5 text-red-500" aria-hidden>*</span>}
      </label>
    )}
    {children}
    {error
      ? <p className="mt-1.5 text-xs text-red-600 dark:text-red-400" role="alert">{error}</p>
      : hint && <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
  </div>
);

export default Field;
